import React from 'react';

function SmsConsent(props) {

  return (
    <div className="page">
      <div className="text_block_white" style={{textAlign: "left"}}>
        <h3>Text Last Mountain Wireless</h3>
        <p>
          You can contact Last Mountain Wireless by text message for customer
          support, service availability, installation scheduling, account
          questions, outage updates, payment confirmations, and other
          service-related messages.
        </p>

        <div style={{
          border: "2px solid #273a63",
          borderRadius: "10px",
          padding: "24px",
          margin: "28px 0",
          background: "#f7f9fc",
          textAlign: "center"
        }}>
          <h4>Opt in by text</h4>
          <p style={{fontSize: "22px", marginBottom: "8px"}}>
            Text <strong>START</strong> to <strong>306.900.4321</strong>
          </p>
          <p>
            I agree to receive recurring automated text messages at the phone
            number provided. Msg & data rates may apply. Msg frequency varies.
            Reply HELP for help and STOP to cancel. View our
            <a className="black_link" href="/terms"> Terms of Service</a> and
            <a className="black_link" href="/privacy"> Privacy Policy</a>.
          </p>
          <p>
            By texting START to 306.900.4321, you agree to receive recurring
            automated and non-automated text messages from Last Mountain
            Wireless at the phone number used to text us. Message and data
            rates may apply. Message frequency varies. Reply HELP for help and
            STOP to cancel. View our
            <a className="black_link" href="/terms"> Terms of Use</a> and
            <a className="black_link" href="/privacy"> Privacy Policy</a>.
          </p>
          <p>
            Consent to receive marketing text messages is not required to buy
            Internet service from Last Mountain Wireless.
          </p>
          <p>
            <a className="btn btn-primary" href="sms:+13069004321&body=START">Text START</a>
          </p>
        </div>

        <h5>Customer support by text</h5>
        <p>
          If you text us about an existing service issue, installation, payment,
          or account question, we may reply by text to help with that specific
          request. If you would also like to receive ongoing service-related
          texts from us, use the START opt-in above.
        </p>

        <h5>Opt out</h5>
        <p>
          You can opt out of text messages at any time by replying STOP. For
          help, reply HELP, call or text
          <a className="black_link" href="tel://13069004321"> 1.306.900.4321</a>,
          or email <a className="black_link" href="mailto:info@lmw.email">info@lmw.email</a>.
        </p>
      </div>

    </div>);

}

export default SmsConsent;
